import React, { useRef } from 'react';
import { MetaPixel } from './components/MetaPixel';
import { Hero } from './components/sections/Hero';
import { SpecialOffer } from './components/sections/SpecialOffer';
import { Stats } from './components/sections/Stats';
import { Transformation } from './components/sections/Transformation';
import { PainPoints } from './components/sections/PainPoints';
import { Framework } from './components/sections/Framework';
import { Volumes } from './components/sections/Volumes';
import { Tools } from './components/sections/Tools';
import { Bonuses } from './components/sections/Bonuses';
import { ValueStack } from './components/sections/ValueStack';
import { Urgency } from './components/sections/Urgency';
import { Guarantee } from './components/sections/Guarantee';
import { Testimonials } from './components/sections/Testimonials';
import { Author } from './components/sections/Author';
import { FAQ } from './components/sections/FAQ';
import { FinalCTA } from './components/sections/FinalCTA';
import { Footer } from './components/sections/Footer';
import { StickyCTA } from './components/StickyCTA';
import { PurchasePopup } from './components/PurchasePopup';
export function App() {
  const heroCtaRef = useRef<HTMLAnchorElement>(null);
  return <div className="w-full bg-ink font-sans" data-id="element-0" data-mp="3relvsk63foaa">
      <MetaPixel data-id="element-1" data-mp="4wx1t3d72hu" />
      <Hero ctaRef={heroCtaRef} data-id="element-2" data-mp="5gg5d4r3wxg" />
      <main data-id="element-3" data-mp="2zl39tfhhuw2o">
        <SpecialOffer data-id="element-4" data-mp="2zld2jatxbhc2" />
        <Stats data-id="element-5" data-mp="2zm4y4lnitf2c" />
        <Transformation data-id="element-6" data-mp="2zmemk4sx3e5x" />
        <PainPoints data-id="element-7" data-mp="2zn6bwxvx8fnr" />
        <Framework data-id="element-8" data-mp="33morde4z3yj7" />
        <Volumes data-id="element-9" data-mp="33lwxq8uxsavk" />
        <Tools data-id="element-10" data-mp="33nges1of2pye" />
        <Bonuses data-id="element-11" data-mp="33n6wl09m5n39" />
        <ValueStack data-id="element-12" data-mp="33orla998ybt7" />
        <Urgency data-id="element-13" data-mp="38m1fs3bhtdnw" />
        <Guarantee data-id="element-14" data-mp="38li95irambp6" />
        <Testimonials data-id="element-15" data-mp="38l04pyuh8r66" />
        <Author data-id="element-16" data-mp="38kgocmkh6au9" />
        <FAQ data-id="element-17" data-mp="38o4f5dyjcj5a" />
        <FinalCTA data-id="element-18" data-mp="3dkl4ucldv5kh" />
      </main>
      <Footer data-id="element-19" data-mp="3dlw4q1bpjt6b" />
      <StickyCTA targetRef={heroCtaRef} data-id="element-20" data-mp="3dmfqjt4hb1pm" />
      <PurchasePopup data-id="element-21" data-mp="nvj3jfxq0epq" />
    </div>;
}